import { Loan, patchUpdateLoanApplicationInLender } from '@nemuru-eng/js-api-client';

import { ActionDialog } from '@/components/shared/components/ActionDialog';
import { Text } from '@/components/shared/components/Text';
import { useRequest } from '@/hooks/requests/useRequest';

interface UpdateLoanApplicationInLenderDialogProps {
  loan: Loan;
  opened: boolean;
  setOpened: (value: boolean) => void;
  handleClose: () => void;
}

export const UpdateLoanApplicationInLenderDialog = ({
  loan,
  opened,
  setOpened,
  handleClose,
}: UpdateLoanApplicationInLenderDialogProps) => {
  const { request, loading } = useRequest();

  const onSubmit = async () => {
    if (loan.loanApplicationSelected) {
      try {
        await request(patchUpdateLoanApplicationInLender, { id: loan.loanApplicationSelected.id, loanId: loan.id });
      } catch (error) {
        console.log(error);
      } finally {
        handleClose();
      }
    }
  };

  return (
    <ActionDialog
      opened={opened}
      setOpened={setOpened}
      handleClose={handleClose}
      Title={<Text tId={'UPDATE_LOAN_APPLICATION_IN_LENDER'} />}
      Description={<Text tId={'UPDATE_LOAN_APPLICATION_IN_LENDER_DESCRIPTION'} />}
      MainButton={<Text tId={'UPDATE_LOAN_APPLICATION'} />}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
};
